<div class="w-4/5 mx-auto">
    <form class="otp-form" (ngSubmit)="getOtp()" [formGroup]="form">
        <h1 class="accent-title">OTP</h1>
        <p>Please enter the OTP received on your registered mobile number</p>
        <div class="grid grid-cols-5 gap-4 mt-10">
            <mat-form-field appearance="fill" color="primary" *ngFor="let input of formInput;  index as i">
                <input maxlength="1" matInput #formRow type="number" formControlName="{{input}}" class="form-control"
                    maxlength="1" (keyup)="keyUpEvent($event, i)">
            </mat-form-field>
        </div>
        <div class="button-wrapper mt-4 mb-2">
            <button type="submit" mat-flat-button color="primary" spinnerButton   [loading]="isLoading"><span *ngIf="!isLoading">Confirm</span></button>
        </div>
        <div *ngIf="errorMessage" class="text-red-700 text-sm">{{errorMessage}}</div>
    </form>
    <div *ngIf="otpCounter < 2" class="my-1 resend-wrap text-center flex items-center"
        [ngClass]="timeLeft < 1? 'justify-end': 'justify-between'">
        <p class="m-0" *ngIf="timeLeft > 0">Resend OTP in <span class="font-medium text-red-700">{{remainingTime |
                date:'mm:ss'}}</span></p>
        <button (click)="resendOtp()" [disabled]="timeLeft>0" mat-button>Resend</button>
    </div>
    <div *ngIf="otpCounter >= 2" class="my-1 text-center">
        <p>You've exceeded OTP usage limit </p>
    </div>
</div>